

/**
 * Profile
 */
export default class UserProfile {

    // constructor
    constructor(selector) {

        let _this = this;
        this.$plugin = $(selector);

        // cancel if non existing element
        if (this.$plugin.length === 0) {
            return false;
        }

        // check router event
        window.addEventListener("router", function (e) {

            // routing switch
            switch (e.detail.path) {
                case '#!/0':
                    _this.editProfile();
                    break;
                case '#!/1':
                    _this.editPasswort();
                    break;
            }
        });
    }


    editProfile() {
        let vm = this;
        const $el = vm.$plugin.find('[data-tncp-profile-xhr]');
        const xhrUrl = $el.data('tncpProfileXhr');

        // load form
        window.xhrRequest({
            url: xhrUrl,
            method: 'GET'
        }).then((response) => {
            $el.html(response.data);
        });

        // submit form
        $el.on('submit', $el.find('form'), (event) => {
            let $form = $el.find('form');
            let formData = $form.serialize();

            // remove error classes if exists
            $form.find('*').removeClass('has-warning');

            // reset container visibility
            $form.find('[data-tncp-form-container="error"]').hide();
            $form.find('[data-tncp-form-container="success"]').hide();
            $form.find('[data-tncp-form-container="form"]').show();

            // disable all form fields
            $form.find('input, select, textarea').attr('disabled', true);

            // validate form
            window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
                data: formData
            }).then((response) => {

                // enable all form fields
                $form.find('input, select, textarea').removeAttr('disabled');

                // if false, do error stuff, otherwise go to else-case
                if (response.data.validation === false) {

                    // scroll to top of form
                    $('body, html').animate({
                        scrollTop: $form.offset().top
                    }, 600);

                    // add error classes
                    _.forEach(response.data.errorFields, (fieldName, index) => {
                        $form.find('#formfield_' + fieldName).addClass('has-warning');
                        $form.find('[for="formfield_' + fieldName + '"], .formfield_' + fieldName).addClass('has-warning');
                    });

                    // show alert message
                    $form.find('[data-tncp-form-container="error"]').show();

                } else {
                    $form.find('[data-tncp-form-container="form"]').hide();
                    $form.find('[data-tncp-form-container="success"]').show();
                }

            });

            // prevent default behaviour
            event.preventDefault();
        });

    }

    editPasswort() {
        console.log('editPasswort');

    }


}